import { useEffect, useState } from "react";

import { Outlet } from "react-router";

import { ActivityType } from "__graphql__/types";
import { ActivityRouteTracker } from "flows/Activities/components/ActivityRouteTracker";
import { restockingActivityCoordinator } from "flows/Activities/coordinator/restockingActivityCoordinator";
import { useRestockingServiceStore } from "flows/Inventory/flows/RestockingList/stores/restockingServiceStore";

export function StockCorrectionActivityTracker() {
  const [isFromRestocking] = useState(
    () => useRestockingServiceStore.getState().isNavigatingToStockCorrection,
  );

  useEffect(() => {
    if (!isFromRestocking) return;
    return () => {
      restockingActivityCoordinator.end({ defer: true });
    };
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isFromRestocking) {
    return <Outlet />;
  }

  return <ActivityRouteTracker activityType={ActivityType.inventory_checks} />;
}
